define('bizzabo/views/main/CommunityView',[
    'jquery',
    'backbone',
    'underscore',
    'jquery-placeholder',
    'bizzabo/config',
    'bizzabo/bzapi',
    'bizzabo/models/Global',
    'bizzabo/models/community/PersonSearch',
    'bizzabo/models/community/Query',
    'bizzabo/models/community/PersonCollection',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/views/main/MainView',
    'bizzabo/views/PushMsgsBoxView',
    'bizzabo/views/right/CommunityPreviewView',
    'hbars!bizzabo/templates/community',
    'hbars!bizzabo/templates/communityStatusLine',
    'hbars!bizzabo/templates/communityPersonRow',
    'hbars!bizzabo/templates/communityEmpty'
], function(
    $,
    Backbone,
    _,
    jqueryPlaceholder,
    CONFIG,
    BZAPI,
    Global,
    PersonSearch,
    Query,
    PersonCollection,
    UTILS,
    Consts,
    MainView,
    PushMsgsBoxView,
    CommunityPreviewView,
    CommunityBuilderView,
    communityTemplate,
    communityStatusLineTemplate,
    communityPersonRowTemplate,
    communityEmptyTemplate
    ) {

    var CommunityView = MainView.extend({

        tabClass : Consts.UI.tabClasses.COMMUNITY,

        prepare : function() {
            var eventId = this.model.get('id');
            var servicePlan = Global.modelPool.getServicePlan(eventId);
            this.prepareModels([this.model, servicePlan]);
        },

        render : function() {
            this.renderMainView({
                hasDetails : true,
                detailsSizeClass : 'width740 scrollable'
            });

            this.putContentView(new CommunityContentView({
                model : this.model,
                communityView : this
            }));
        },

        remove : function() {
            this.removeMainView();
        }
    });

    var CommunityContentView = Backbone.View.extend({

        events : {
            'click .community-people-table-trash' : 'deletePerson',
            'click .messageBox-see-how-look' : 'showPreview'
        },

        initialize : function() {
            this.query = new Query({
                id: this.model.get('id')
            });

            this.personSearch = new PersonSearch({});
            this.personSearch.setQuery(this.query);

            this.personList = new PersonCollection();
            this.personList.setPersonSearch(this.personSearch);
            this.listenTo(this.personList, 'remove reset', this.renderPersonsList);
            this.listenTo(this.personList, 'add', this.renderPerson);
            this.listenTo(Backbone, 'mail-list-updated', this.mailListUpdated);

            if (this.model.get('id')){
                this.personSearch.fetch();
            }
            this.listenTo(this.model, 'change:event-is-active', this.disableViewIfNeed);
            this.bindScrolling();
        },

        disableViewIfNeed: function() {
            if (this.model.get('event-is-active')) {
                this.$('textarea').attr('disabled', 'disabled');
                this.$('.flatButton').toggleClass('disabled', true);
                this.$('.button, .community-people-table-trash, aside').toggleClass('hide', true);
            } else {
                this.$('textarea').removeAttr('disabled', 'disabled');
                this.$('.flatButton').toggleClass('disabled', false);
                this.$('.button, .community-people-table-trash, aside').toggleClass('hide', false);
                this.pushMsgsBoxView.render();
            }
        },

        bindScrolling: function() {
            var windowElement = $(window);
            windowElement.scroll(function() {
                var scrollTop = $(this).scrollTop();
                var offsetFromBottom = 200;
                if (scrollTop + windowElement.height() >= $(document).height() - offsetFromBottom) {
                    Backbone.trigger('scrolled-to-bottom');
                }
            });
        },

        unbindScrolling: function() {
            $(window).unbind('scroll');
        },

        remove : function() {
            this.unbindScrolling();
            this.pushMsgsBoxView.remove();
            this.communityBuilderView.remove();
            this.searchPersonView.remove();
            this.sortTableHeadView.remove();
            this.statusLineView.remove();

            this.off();
            this.$el.remove();
        },

        render : function() {
            var html = communityTemplate(this.model.toJSON());
            this.$el.html(html);

            this.pushMsgsBoxView = new PushMsgsBoxView({
                el : this.$('.community-real-time-container'),
                model : this.model
            });
            this.pushMsgsBoxView.render();

            this.$('.community-real-time-container textarea').placeholder();

            this.communityBuilderView = new CommunityBuilderView({
                model : this.model
            });

            this.searchPersonView = new SearchPersonView({
                model: this.query,
                el: this.$('.searchContainer')
            });

            this.$('.searchContainer input.searchInput').placeholder();

            this.sortTableHeadView = new SortTableHeadView({
                model: this.query,
                el: this.$('.community-people-table-head-row')
            });

            if (this.personList.length == 0){
                this.renderPersonsList();
            }

            this.statusLineView = new StatusLineView({
                model: this.model,
                personSearch: this.personSearch,
                el: this.$('.community-status-line-wrapper')
            });

            this.options.communityView.putRightPanelView(this.communityBuilderView);
            this.options.communityView.openDetails(true);
            this.disableViewIfNeed();
            return this;
        },

        renderPerson : function(person) {
            var url = CONFIG.EVENTS_URL + '/' + this.model.get('unique-name') + '/person/';
            var peopleTable = this.$('.community-people-table');
            var personEventUrl = url + person.get('id');
            var userAndinTheEvent = (person.get('attending-status') == 'rsvp' || person.get('attending-status') == 'checkedin');
            var source = _.extend(person.toJSON(), {
                'personEventUrl': personEventUrl,
                'deletable': !userAndinTheEvent,
                'showLink': userAndinTheEvent
            });
            peopleTable.append(communityPersonRowTemplate(source));
            this.$('[data-toggle="tooltip"]').tooltip({
                placement : 'bottom'
            });
        },

        renderPersonsList : function() {
            var peopleTable = this.$('.community-people-table');
            this.$('.community-people-table-person-row').remove();

            if (this.personList.length){
                this.personList.each(function(person) {
                    this.renderPerson(person)
                }, this);
            } else {
                peopleTable.append(communityEmptyTemplate());
            }
            this.disableViewIfNeed();
        },

        mailListUpdated : function() {
            var query = this.query;
            _.delay(function() {
                query.trigger('search');
            }, 2000);
        },

        deletePerson : function (e) {
            var errorFn = function() {
                Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                    msg : 'Could not remove this person.',
                    errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.ERROR,
                    autoHide : true
                });
            };

            var thisView = this;
            var personId = $(e.target).attr('data-personId');
            BZAPI.deletePersonInEvent(this.model.get('id'), personId, function(data){
                Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                    msg : 'Removed',
                    errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.SUCCESS,
                    autoHide : true
                });
                setTimeout(function() {
                    thisView.query.trigger('search');
                }, 1500);
                this.$('#person-row-'+personId).fadeOut();
            }, errorFn);
        },

        showPreview: function () {
            new CommunityPreviewView({
                model : this.model
            }).show();
        }

    });

    var StatusLineView = Backbone.View.extend({

        events: {
            'click a': 'linkClicked'
        },

        initialize: function (options) {
            this.personSearch = options.personSearch;
            this.listenTo(options.personSearch, 'change:total change:facets', this.changeLine);
            this.listenTo(this.model, 'change:aggregated-data-rsvp-count change:source change:invite-guests', this.changeLine);
            this.listenTo(this.model, 'change:event-is-active', this.disableViewIfNeed);
            this.changeLine();
        },

        disableViewIfNeed: function() {
            this.$('.button').toggleClass('hide', this.model.get('event-is-active'));
        },

        changeLine: function () {
            this.statusLineData = this.statusLineData || {
                eventId: this.model.get('id'),
                totalCount : 0,
                didUpload : false,
                rsvpCount : 0,
                source : undefined,
                inviteGuests : false,
                callToAction : {
                    widget: false,
                    autoSend : false,
                    connectReg : false
                }
            };

            var facets = this.personSearch.get('facets') && this.personSearch.get('facets').attributes;
            if (facets && facets.status && this.personSearch.query.get('q') == '') {
                var statusFacet = facets.status;
                this.statusLineData.didUpload = statusFacet.invited || statusFacet.inprogress || statusFacet.bounced || statusFacet.notinvited;
                this.statusLineData.rsvpCount = (statusFacet.rsvp || 0) + (statusFacet.checkedin || 0);

                this.statusLineData.totalCount = this.personSearch.get('total');
                this.statusLineData.source = this.model.get('source');
                this.statusLineData.inviteGuests = this.model.get('invite-guests');
            }

            this.checkCallToAction();
            this.render();

        },

        checkCallToAction: function () {
            var callToAction  = {};
            if (this.statusLineData.totalCount >=50){
                callToAction.widget = true;
            } else {
                if (!(this.statusLineData.didUpload || this.statusLineData.source)) {
                    callToAction.connectReg = true;
                } else {
                    if (this.statusLineData.inviteGuests) {
                        callToAction.widget = true;
                    } else {
                        callToAction.autoSend = true;
                    }
                }
            }

            this.statusLineData.callToAction = callToAction;
        },

        linkClicked: function (e) {
            var step = $(e.target).attr('data-step');
            Backbone.trigger('details-open');
            if (step) {
                Backbone.trigger('roll-to-step', step);
            }
        },

        render: function () {
            this.$el.html(communityStatusLineTemplate(this.statusLineData));
            this.disableViewIfNeed();
        }

    });

    var SearchPersonView = Backbone.View.extend({

        events : {
            'input input' : 'inputChanged',
            'keyup input': 'inputKeyup'
        },

        inputChanged: _.debounce(function(e) {
            var q = e.target.value;
            this.model.set('q', q);
            if (q == '' && !this.model.get('sort')){
                this.model.set('sort','name');
            }
        }, 300),

        inputKeyup: function(e) {
            var backspaceKey = 8;
            if (e.keyCode == backspaceKey) {
                this.inputChanged(e);
            }
        }

    });

    var SortTableHeadView = Backbone.View.extend({

        events : {
            'click .community-people-table-head-row-field' : 'fieldHeadChanged'
        },

        initialize: function() {
            this.toggleOrderMap = {
                name : 'asc'
            };
            this.renderToolTips();
        },

        fieldHeadChanged: function (e) {
            var sort = $(e.target).attr('name') || $(e.target.parentElement).attr('name');
            if (sort){
                this.toggleOrder(sort);
                this.model.set('sort', sort);
            }
        },

        toggleOrder: function (sortName) {
            if (this.toggleOrderMap[sortName]){
                switch(this.toggleOrderMap[sortName]){
                    case 'asc':
                        this.toggleOrderMap[sortName] = 'desc';
                        break;
                    case 'desc':
                        this.toggleOrderMap[sortName] = 'asc';
                        break;
                }
            } else {
                this.toggleOrderMap[sortName] = 'asc';
            }

            this.model.set('sort-order', this.toggleOrderMap[sortName]);
            var arrowImglink = 'images/community/arrow-';
            if (this.toggleOrderMap[sortName] == 'desc'){
                arrowImglink = arrowImglink + 'down.png' ;
            }
            if (this.toggleOrderMap[sortName] == 'asc') {
                arrowImglink = arrowImglink + 'up.png' ;
            }
            this.$('.community-people-table-head-row-field img.community-people-table-head-row-arrows').attr('src', '');
            this.$('.community-people-table-head-row-field img.community-people-table-head-row-arrows').addClass('hide');

            this.$('.community-people-table-head-row-field[name="' + sortName + '"] img.community-people-table-head-row-arrows').attr('src', arrowImglink);
            this.$('.community-people-table-head-row-field[name="' + sortName + '"] img.community-people-table-head-row-arrows').removeClass('hide');

        },

        renderToolTips : function() {
            this.$('[data-toggle="tooltip"]').tooltip({
                placement : 'top',
                html: true
            });
        }

    });

    return CommunityView;
    
});
